// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1OAuthAuthorizedApplicationSchema } from './v1/oAuth/authorizedApplicationSchema';

export const listAuthorizedApplicationsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description authorized applications
 */
export const listAuthorizedApplications200Schema = z.array(z.lazy(() => v1OAuthAuthorizedApplicationSchema));

/**
 * @description unauthorized
 */
export const listAuthorizedApplications401Schema = z.unknown();

export const listAuthorizedApplicationsQueryResponseSchema = z.lazy(() => listAuthorizedApplications200Schema);
